<template>
  <v-container fluid class="gl-map-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Mapping</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Mapping</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_glmap.mapcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Map Code"
                          persistent-hint
                          single-line hint="Enter the map code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_glmap.mapname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Map Name"
                          persistent-hint
                          single-line hint="Enter the map name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Map', 'Other Map']"
                          v-model="new_glmap.maptype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the map type">
                        </v-select>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=data_subclasses
                          v-model="accountsubclass1"
                          outlined
                          dense
                          placeholder="Credit Subclass"
                          persistent-hint
                          single-line hint="Please choose the subclass">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(account=>account.accountsubclass==accountsubclass1).map(x => {
                            return {text: x.accountname, value: x._id};
                            })"
                          v-model="new_glmap.credit_accountid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Credit Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=data_subclasses
                          v-model="accountsubclass2"
                          outlined
                          dense
                          placeholder="Debit Subclass"
                          persistent-hint
                          single-line hint="Please choose the subclass">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                            return {text: x.accountname, value: x._id};
                            })"
                          v-model="new_glmap.debit_accountid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Debit Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/gl-map/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertGLMap()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      new_glmap: {},
      error: undefined,
      haserror: false,
      errorindex: undefined,
      accountsubclass1: null,
      accountsubclass2: null,
      classes: ['Bank', 'Current Asset', 'Current Liability', 'Sales Income', 'Service Income', 'Cost of Goods Sold', 'Salary', 'Salary Items', 'Other Income', 'Other Expense'],
    }
  },

  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('GLMap', ['insertGLMapRequest','getGLMapsRequest']),
    checkError(){
      if(!this.new_glmap.mapcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_glmap.mapname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_glmap.maptype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertGLMap() {
      await this.insertGLMapRequest(this.new_glmap)
      router.push('/gl-map/list')
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLMap', ['isReceiving']),
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountstatus=='New' || account.accountstatus=='Active');
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return [...result];
    },
  },
  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
